import { useRef, useState } from "react";

import { Spacer, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import ThumbDown from "@/assets/images/customer_mood_thumb_down_grey.svg?react";
import ThumbDownActive from "@/assets/images/customer_mood_thumb_down_grey_active.svg?react";
import ThumbUp from "@/assets/images/customer_mood_thumb_up_grey.svg?react";
import ThumbUpActive from "@/assets/images/customer_mood_thumb_up_grey_active.svg?react";

import { FeedbacksProps } from ".";

export function Feedbacks({
  onClickThumbDown,
  onClickThumbDownUpdated,
  onClickThumbUp,
  onClickThumbUpUpdated,
}: FeedbacksProps) {
  const { t } = useTranslation();

  const [feedback, setFeedback] = useState<
    "customer_mood.agree" | "customer_mood.dont_agree" | null
  >(null);
  const previousRating = useRef<
    "customer_mood.agree" | "customer_mood.dont_agree" | null
  >(null);

  const handleResetOnClick = () => {
    previousRating.current = feedback;
    setFeedback(null);
  };
  const handleThumbUpOnClick = () => {
    if (!previousRating.current || !onClickThumbUpUpdated) {
      onClickThumbUp();
    } else {
      onClickThumbUpUpdated(previousRating.current);
    }

    setFeedback("customer_mood.agree");
  };
  const handleThumbDownOnClick = () => {
    if (!previousRating.current || !onClickThumbDownUpdated) {
      onClickThumbDown();
    } else {
      onClickThumbDownUpdated(previousRating.current);
    }
    setFeedback("customer_mood.dont_agree");
  };

  if (Boolean(feedback) && feedback === "customer_mood.agree") {
    return (
      <Spacer
        data-test="customer-mood-thumb-up-active"
        gap="xxxs"
        alignItems="center"
        onClick={handleResetOnClick}
        cursor="pointer"
      >
        <ThumbUpActive height={16} width={16} />
        <Typography color="text-secondary" variant="supportingMediumS">
          {t(feedback)}
        </Typography>
      </Spacer>
    );
  }

  if (Boolean(feedback) && feedback === "customer_mood.dont_agree") {
    return (
      <Spacer
        data-test="customer-mood-thumb-down-active"
        gap="xxxs"
        alignItems="center"
        onClick={handleResetOnClick}
        cursor="pointer"
      >
        <ThumbDownActive height={16} width={16} />
        <Typography color="text-secondary" variant="supportingMediumS">
          {t(feedback)}
        </Typography>
      </Spacer>
    );
  }

  return (
    <Spacer gap="s">
      <ThumbUp
        data-test="customer-mood-thumb-up"
        height={16}
        width={16}
        onClick={handleThumbUpOnClick}
        cursor="pointer"
      />
      <ThumbDown
        data-test="customer-mood-thumb-down"
        height={16}
        width={16}
        onClick={handleThumbDownOnClick}
        cursor="pointer"
      />
    </Spacer>
  );
}
